import {
  CORE_GET_CATEGORY_INFO_REQUEST,
  CORE_GET_CATEGORY_INFO_SUCCESS,

  CORE_SEARCH_ALL_FBS_CATEGORY_REQUEST,
  CORE_SEARCH_ALL_FBS_CATEGORY_SUCCESS,

  CORE_LOAD_ALL_CATEGORY_REQUEST,
  CORE_LOAD_ALL_CATEGORY_SUCCESS,

} from '../../types'

const initialState = []
export default {
  fbCategoryInfo: (state = initialState, action) => {
    switch (action.type) {
      case CORE_GET_CATEGORY_INFO_REQUEST:
        return {}

      case CORE_GET_CATEGORY_INFO_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  fbCategory: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_CATEGORY_REQUEST:
      case CORE_SEARCH_ALL_FBS_CATEGORY_REQUEST:
        return initialState

      case CORE_LOAD_ALL_CATEGORY_SUCCESS:
      case CORE_SEARCH_ALL_FBS_CATEGORY_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/features/fbCategory/reducer.js